import { render } from "./Grouping.vue?vue&type=template&id=310467fc&ts=true"
import script from "./Grouping.vue?vue&type=script&lang=ts"
export * from "./Grouping.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__